import gql from 'graphql-tag';

export default gql`
    mutation AddJobNotes($input: AddJobNotesInput) {
        addJobNotes(input: $input) {
            errors
            createdJobNotesId
        }
    }
`;
